/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Empty_Capture_HintInputs */

const en_mobile_notes_empty_capture_hint = /** @type {(inputs: Mobile_Notes_Empty_Capture_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes yet. Add note captures what is being read right now.`)
};

const es_mobile_notes_empty_capture_hint = /** @type {(inputs: Mobile_Notes_Empty_Capture_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay notas. Agregar nota captura lo que se está leyendo ahora.`)
};

/**
* | output |
* | --- |
* | "No notes yet. Add note captures what is being read right now." |
*
* @param {Mobile_Notes_Empty_Capture_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_empty_capture_hint = /** @type {((inputs?: Mobile_Notes_Empty_Capture_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Empty_Capture_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_empty_capture_hint(inputs)
	return en_mobile_notes_empty_capture_hint(inputs)
});